import { useReveal } from "../hooks/useReveal";
import { Navbar } from "../components/Navbar";
import { FloatingWhatsApp } from "../components/FloatingWhatsApp";
import { Hero } from "../components/sections/Hero";
import { VideoSection } from "../components/sections/VideoSection";
import { About } from "../components/sections/About";
import { HowItHelps } from "../components/sections/HowItHelps";
import { Couples } from "../components/sections/Couples";
import { Modalities } from "../components/sections/Modalities";
import { Process } from "../components/sections/Process";
import { Testimonials } from "../components/sections/Testimonials";
import { FAQ } from "../components/sections/FAQ";
import { FinalCTA } from "../components/sections/FinalCTA";
import { Footer } from "../components/sections/Footer";

export default function Landing() {
    useReveal();

    return (
        <main data-testid="landing-page" className="min-h-screen bg-[#F5F4F2] text-[#2F2F2F]">
            <Navbar />
            <Hero />
            <VideoSection />
            <About />
            <HowItHelps />
            <Couples />
            <Modalities />
            <Process />
            <Testimonials />
            <FAQ />
            <FinalCTA />
            <Footer />
            <FloatingWhatsApp />
        </main>
    );
}
